export default "__VITE_ASSET__H85XJ$fr__"